import { observer } from 'mobx-react-lite'
import { SelectAppAndNumbersCommon } from 'pages/settings/ui/SelectAppAndNumbersCommon/SelectAppAndNumbersCommon'
import { useNewInboxStepsContext } from 'pages/settings/pages/inboxes/pages/newInbox/context/newInboxStepsContext'
import styles from './styles.module.scss'

export const SelectAppAndNumbers = observer(() => {
  const { nextClickHandler, selectAppAndNumbersStore } = useNewInboxStepsContext()

  return (
    <div className={styles.root}>
      <SelectAppAndNumbersCommon
        store={selectAppAndNumbersStore}
        nextClickHandler={nextClickHandler}
      />
    </div>
  )
})
